<div class="w-100">
  <div *ngIf="showLabel" class="label-text">
    <span class="d-inline-flex">
      <label>{{ labelText }}</label>
      <mat-icon *ngIf="!hideTitleIcon" class="info-icon" svgIcon="info"></mat-icon>
    </span>
    <span class="d-inline-flex" *ngIf="selectedIcon" (click)="removeIcon()">
      <mat-icon class="trash-icon" svgIcon="trash"></mat-icon>
      <a class="remove-link" href="" (click)="$event.preventDefault()">Remove</a>
    </span>
  </div>
  <button
    id="add-icon"
    class="btn w-100 mt-2"
    type="button"
    (click)="showLibrary(true)"
    *ngIf="!selectedIcon"
  >
    Add Icon
  </button>
  <button
    id="replace-icon"
    class="btn w-100 mt-2"
    type="button"
    (click)="showLibrary(true)"
    *ngIf="selectedIcon"
  >
    Replace
    <mat-icon svgIcon="arrow-up-right"></mat-icon>
  </button>
</div>
<div class="icon-lib-tab" *ngIf="showLib">
  <div class="lib-header">
    <h2>Icon Library</h2>
    <mat-icon svgIcon="close" (click)="showLibrary(false)"></mat-icon>
  </div>

  <div class="search-input-wrapper">
    <mat-icon svgIcon="search-icon" (click)="showLibrary(false)"></mat-icon>
    <input class="search-input" placeholder="Search icon library..." (input)="onSearch($event)" />
  </div>

  <ul>
    <ng-container *ngIf="projectIcons?.length">
      <p class="mb-1">Your Project Icons</p>
      <li
        *ngFor="let icon of projectIcons"
        (click)="selectIcon(icon.iconNamespace + ':' + icon.iconName)"
        title="{{ icon.iconNamespace }}:{{ icon.iconName }}"
      >
        <mat-icon [svgIcon]="icon.iconNamespace + ':' + icon.iconName"></mat-icon>
      </li>
    </ng-container>

    <ng-container *ngFor="let set of iconSets">
      <p class="mb-1">{{ set.header }}</p>
      <li *ngFor="let icon of set.icons" (click)="selectIcon(icon.name)">
        <mat-icon [svgIcon]="icon.name"></mat-icon>
      </li>
    </ng-container>
  </ul>
</div>
